var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_358",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4279",
    "data-name": "Rectangle 4279",
    width: 59.404,
    height: 43.539,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10451",
    "data-name": "Group 10451",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Ellipse_358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_358-2",
    "data-name": "Ellipse 358",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275",
    transform: "translate(14.807 23.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44388",
    "data-name": "Path 44388",
    d: "M5.783,38.2c-.888,0-1.7,0-2.511,0A3.21,3.21,0,0,1,.021,35.047c-.026-.639-.012-1.28-.012-1.92Q.008,18.393,0,3.66A3.19,3.19,0,0,1,1.463.6,4.665,4.665,0,0,1,3.581.039C6.139-.027,8.7.012,11.261.012q19.233,0,38.467.005a5.88,5.88,0,0,1,1.506.136,3.254,3.254,0,0,1,2.391,3.267c.017.615,0,1.23,0,1.931.814,0,1.579,0,2.345,0A3.224,3.224,0,0,1,59.4,8.8c.015,4.128,0,8.255,0,12.383q0,9.4,0,18.806a3.218,3.218,0,0,1-2.362,3.4,5.211,5.211,0,0,1-1.373.139q-23.074.01-46.147,0c-2.431,0-3.724-1.291-3.734-3.707,0-.507,0-1.014,0-1.631M32.617,42.18h23.1c1.6,0,2.329-.736,2.329-2.356q0-15.394,0-30.787c0-1.6-.734-2.335-2.353-2.336q-23.1,0-46.206,0c-1.6,0-2.31.71-2.31,2.293q0,15.427,0,30.853c0,1.626.707,2.332,2.334,2.332h23.1M5.783,36.8v-.864c0-8.916.034-17.833-.022-26.749A3.589,3.589,0,0,1,9.58,5.321c13.924.062,27.848.031,41.772.031h.873c0-.81.042-1.538-.01-2.259-.079-1.085-.945-1.721-2.267-1.721H3.872c-1.845,0-2.511.665-2.511,2.507q0,15.229,0,30.457a6.43,6.43,0,0,0,.017.727,1.793,1.793,0,0,0,1.568,1.712c.909.093,1.836.021,2.836.021",
    transform: "translate(0 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44389",
    "data-name": "Path 44389",
    d: "M193.279,60.246a5.826,5.826,0,0,1,1.079-3.433,23.245,23.245,0,0,1,14.658-10.162,3.378,3.378,0,0,1,3.9,1.326c.723.969,1.607,1.817,2.4,2.734a.947.947,0,0,1-.346,1.648q-2.212,1.037-4.443,2.034a1.443,1.443,0,0,1-2.09-.626c-.012-.018-.022-.038-.035-.056-1.193-1.722-.555-1.562-2.614-.92a9.844,9.844,0,0,0-5.8,4.535,1.378,1.378,0,0,0,.109,1.745c1.334,1.716,1.337,1.767-.075,3.479-.842,1.02-1.726,2.006-2.612,2.99a.927.927,0,0,1-1.635-.105c-.569-.839-1.134-1.68-1.684-2.532a4.566,4.566,0,0,1-.818-2.655m20.415-9.024c-.965-1.064-1.872-2.079-2.8-3.07a.676.676,0,0,0-.538-.127c-.906.175-1.818.341-2.7.592a20.758,20.758,0,0,0-9.734,6.2,23.71,23.71,0,0,0-2.682,3.74,3.023,3.023,0,0,0-.025,3.1c.431.781.979,1.5,1.532,2.328l2.729-3.2-.424-.546c-1.2-1.539-1.22-2.412-.173-4.077a12.146,12.146,0,0,1,8.162-5.349,1.553,1.553,0,0,1,1.7.614c.365.494.722.994,1.124,1.549l3.842-1.76",
    transform: "translate(-159.083 -38.28)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44390",
    "data-name": "Path 44390",
    d: "M70.2,127.184a3.793,3.793,0,0,0,1.928-3.119c.037-.774.466-1.092,1.2-.839a27.048,27.048,0,0,1,3.55,1.394,4.667,4.667,0,0,1,2.649,4.338c.025,2.074.012,4.149.006,6.223,0,.76-.268,1.023-1.045,1.024q-8.274.007-16.548,0c-.805,0-1.084-.279-1.085-1.065,0-2.074-.035-4.149.01-6.223a4.577,4.577,0,0,1,2.415-4.143,28.292,28.292,0,0,1,3.9-1.583c.607-.22,1.034.125,1.074.782a3.905,3.905,0,0,0,1.953,3.211m-3.455-2.4a22.51,22.51,0,0,0-3.024,1.618,3.8,3.8,0,0,0-1.143,1.781,6.367,6.367,0,0,0-.15,1.961c-.017,1.472-.005,2.944-.005,4.443H77.906c0-2.107.034-4.177-.027-6.243a2.625,2.625,0,0,0-.57-1.312c-.891-1.243-2.309-1.591-3.7-2.147a5.98,5.98,0,0,1-2.761,3.815,1,1,0,0,1-1.32-.01,6.166,6.166,0,0,1-2.787-3.906",
    transform: "translate(-50.07 -101.343)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44391",
    "data-name": "Path 44391",
    d: "M87.9,62.192a4.347,4.347,0,0,1-4.115-3.071,3.046,3.046,0,0,0-.629-.958,2.711,2.711,0,0,1-.72-2.5c.107-.644.185-1.295.247-1.945.125-1.317.426-2.5,1.944-2.878.172-.043.311-.234.454-.369a5.084,5.084,0,0,1,6.856.127,3.993,3.993,0,0,1,1.232,2.7c.064.872.19,1.74.308,2.607a2.624,2.624,0,0,1-.8,2.278,2.98,2.98,0,0,0-.6.906,4.427,4.427,0,0,1-4.177,3.1m0-1.572c1.324,0,2.245-.814,2.815-2.374a7.731,7.731,0,0,1,.735-1.1,2.21,2.21,0,0,0,.444-1.017,16.733,16.733,0,0,0-.314-2.659,3.836,3.836,0,0,0-.6-1.561,3.436,3.436,0,0,0-4.844-.251c-.38.374-.694.773-1.3.795-.146.005-.351.272-.409.456a6.048,6.048,0,0,0-.17,1.034c-.089.667-.21,1.334-.24,2-.016.344.019.863.233,1.012a3.216,3.216,0,0,1,1.086,1.732A2.648,2.648,0,0,0,87.9,60.62",
    transform: "translate(-67.811 -40.496)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44392",
    "data-name": "Path 44392",
    d: "M211.42,168.067h7.013c.154,0,.309,0,.463,0,.511.005.871.219.879.766.009.583-.357.807-.9.807q-7.443,0-14.886,0c-.542,0-.918-.211-.912-.8s.4-.778.935-.777q3.705,0,7.41,0",
    transform: "translate(-167.149 -138.333)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44393",
    "data-name": "Path 44393",
    d: "M211.389,190.49q3.638,0,7.277,0c.75,0,1.073.229,1.083.754s-.338.811-1.048.812q-7.31,0-14.62,0c-.715,0-1.056-.275-1.048-.811s.324-.755,1.08-.755q3.638,0,7.277,0",
    transform: "translate(-167.114 -156.79)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44394",
    "data-name": "Path 44394",
    d: "M82.436,212.793q2.812,0,5.625,0c.708,0,1.09.282,1.085.775s-.41.791-1.1.792q-5.691.007-11.381,0c-.468,0-.9-.088-1.012-.639s.23-.923.891-.926c1.963-.01,3.926,0,5.889,0",
    transform: "translate(-62.253 -175.146)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44395",
    "data-name": "Path 44395",
    d: "M209.163,212.783c1.7,0,3.4.006,5.1,0,.553,0,.977.138,1.01.772.025.492-.351.8-1,.8q-5.131.011-10.262,0c-.659,0-1-.307-.97-.822.036-.6.438-.747.963-.745,1.721.006,3.443,0,5.164,0",
    transform: "translate(-167.115 -175.136)",
    fill: "#1a1818"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.84c74a2eb196b0ce29fca046270a141d.svg";
export { ForwardRef as ReactComponent };